<section class="container">
  <header>
    <div class="logo-wrapper">
      <img class="logo" src="assets/ReportsFeed_Logo_Color.png" width="190" />
    </div>
    <div class="navigation-wrapper" #navigationWrapper>
      <ng-content select="[slot=link]"></ng-content>
    </div>
  </header>
  <content>
    <ng-content select="[slot=content]"></ng-content>
  </content>
</section>
